export const PERSONA_SPARK_QUERY_KEYS = {
  all: (workspaceId: string) => ['persona-sparks', workspaceId] as const,
  detail: (personaId: string) => ['persona-spark', personaId] as const,
};
